export default __webpack_public_path__ + "images/Caribbean.64557c.jpg";